export default "__VITE_ASSET__BZ0EBKiX__"